export { default as useClipboard } from './useClipboard';
